import { render, staticRenderFns } from "./NewsletterFooter.vue?vue&type=template&id=48347ba8&scoped=true"
import script from "./NewsletterFooter.vue?vue&type=script&lang=js"
export * from "./NewsletterFooter.vue?vue&type=script&lang=js"
import style0 from "./NewsletterFooter.vue?vue&type=style&index=0&id=48347ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48347ba8",
  null
  
)

export default component.exports